import { CopilotConversationDTO } from './copilotConversationDTO';

export class KpiReportChartKindDTO {
  kpiId?: number;

  kind?: string;
}

// The Data of the KpiReport process row (ProcessStateKpiReport, PLAN-070). The client sends the conversation with the
// answered card, and on a start the job or the KPIs it knows; the server fills the rest.
export class TenantProcessStateKpiReportDTO {
  stage?: number;

  jobId?: number;

  reservationId?: string;

  // the panel's context key, sent with the start: the server makes the report's session under it
  contextKey?: string;

  // KpiReportFormat: 0 Pdf, 1 Word; sent with the start when the surface knows it, null or absent is PDF
  format?: number | null;

  kpiIds?: number[];

  start?: string;

  end?: string;

  instructions?: string;

  chartKinds?: KpiReportChartKindDTO[];

  notes?: string;

  conversation: CopilotConversationDTO;

  fileBlockId?: string;

  traceId?: string;

  sessionId?: number;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}
